@if (data.transaction.extendedData; as extendedData) {
  <div class="flex flex-col gap-2 p-2 text-xs">
    @if (extendedData.paymentDate) {
      <div class="flex items-center gap-2">
        <mat-icon class="icon-sm text-success-400">paid</mat-icon>
        <span>
          ACC confirmed paid on
          <strong>{{ extendedData.paymentDate | date: dateFormat }}</strong>
          @if (awaitingConfirmation) {
            &mdash; confirm receipt to reconcile.
          }
        </span>
      </div>
    }

    <div class="flex flex-col gap-1 opacity-70">
      @if (extendedData.awardedAmount) {
        <div class="flex w-48 justify-between">
          <span>ACC Awarded:</span>
          <strong>{{ extendedData.awardedAmount | currency }}</strong>
        </div>
      }
      @if (extendedData.paymentReference) {
        <div class="flex w-full justify-between gap-4">
          <span>Payment Reference:</span>
          <strong>{{ extendedData.paymentReference }}</strong>
        </div>
      }
    </div>
  </div>
}
